'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonLockupStackedBrandAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 93 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.6417 60.0359H19.8821V57.3879H14.7776V55.1666H19.2985V52.7015H14.7776V50.4802H19.8821V47.8408H11.6417V60.0359ZM74.8734 47.5969C71.1888 47.5969 68.7149 50.0969 68.7149 53.9384C68.7149 57.7799 71.1888 60.2799 74.8734 60.2799C78.5668 60.2799 81.032 57.7799 81.032 53.9384C81.032 50.0969 78.5668 47.5969 74.8734 47.5969ZM74.8734 57.475C73.0616 57.475 71.9205 56.2642 71.9205 53.9384C71.9205 51.6126 73.0616 50.4018 74.8734 50.4018C76.694 50.4018 77.8264 51.6126 77.8264 53.9384C77.8264 56.2642 76.694 57.475 74.8734 57.475ZM89.0372 47.8408V54.5569L84.9954 47.8408H81.7463V60.0359H84.7776V53.0412L88.9849 60.0359H92.0685V47.8408H89.0372ZM4.95183 47.8408H0.369934V60.0359H4.95183C8.58423 60.0359 10.9274 57.6405 10.9274 53.9384C10.9274 50.2363 8.58423 47.8408 4.95183 47.8408ZM4.90827 57.3879H3.50583V50.4802H4.90827C6.72012 50.4802 7.73928 51.7607 7.73928 53.9384C7.73928 56.1074 6.72012 57.3879 4.90827 57.3879ZM64.2724 47.8408H61.1365V60.0359H69.0024V57.3966H64.2724V47.8408ZM30.1086 54.7833C28.9152 56.6823 27.7567 57.475 26.2672 57.475C24.3334 57.475 23.2097 56.1161 23.2097 53.7555C23.2097 51.5168 24.2462 50.4018 25.8403 50.4018C26.8943 50.4018 27.7654 50.8722 28.0354 52.4401H31.1713C30.8316 49.4523 28.9239 47.5969 25.8752 47.5969C22.3386 47.5969 20.0128 50.0969 20.0128 53.9297C20.0128 57.7886 22.3386 60.2799 26.1626 60.2799C28.6626 60.2799 30.3612 59.2346 31.4849 57.8234H35.7619V60.0359H38.8804V47.8408H34.4553L30.1086 54.7833ZM35.7619 55.3757H33.0006L35.7619 50.8896V55.3757ZM57.0947 52.4924H52.8699V47.8408H49.7341V60.0359H52.8699V55.1231H57.0947V60.0359H60.2306V47.8408H57.0947V52.4924ZM39.6644 50.4802H42.7393V60.0359H45.8752V50.4802H48.9501V47.8408H39.6644L39.6644 50.4802Z",
          fill: "#3643BA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M58.5453 0.279785C41.8619 0.279785 21.1094 17.5414 21.1094 31.8476C21.1094 39.2363 26.7848 42.9627 34.2805 42.9627C39.7846 42.9627 46.4451 40.9496 52.87 37.0732V8.5251C51.1567 11.4591 43.1041 23.281 36.6363 29.5774C33.3382 32.7899 30.7254 34.182 28.4767 34.182C25.9495 34.182 24.7502 32.4687 24.7502 29.9201C24.7502 18.3552 44.2178 3.32092 57.1104 3.32092C62.4217 3.32092 65.8483 5.67672 65.8483 10.2598C65.8483 14.4575 63 19.7259 58.1384 24.5874V33.4324C66.6193 26.7291 71.695 18.1839 71.695 11.2878C71.695 4.02766 66.0411 0.279785 58.5453 0.279785Z",
          fill: "#3643BA"
        }
      )
    ]
  }
);
const VpLogoDecathlonLockupStackedBrandAsset = forwardRef(LogoDecathlonLockupStackedBrandAsset);

export { VpLogoDecathlonLockupStackedBrandAsset as default };
